import React, { Suspense, lazy } from "react";

import { Button, Result } from 'antd'
import './view/admin.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  createBrowserRouter, RouterProvider, Outlet,
  useNavigate
} from "react-router-dom";


import Delivery from "./view/delivery";
import OutletDelivery from "./view/delivery/outletDelivery";
import Pedidos from "./view/delivery/pedidos";
import Perfil from "./view/delivery/perfil";
import { isMobile } from "react-device-detect";


const Erro404 = (props) => {
  const navigate = useNavigate()
  return <Result
    status="404"
    title="404"
    subTitle="Desculpa, a pagina que você visitou não existe!"
    extra={<Button type="primary" onClick={() => {
      navigate("/")
    }}>Voltar principal</Button>}
  />
}



export const Routes = (props) => {


  //Rotas para DESKTOP
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Outlet />,
      errorElement: <Erro404 {...props} />,
      children: [
        {
          path: "/:nome",
          element: <OutletDelivery />,
          children: [
            {
              path: "/:nome",
              element: <Delivery {...props} />,
            },
            {
              path: "/:nome/pedidos",
              element: <Pedidos {...props} />,
            },
            {
              path: "/:nome/perfil",
              element: <Perfil {...props} />,
            },
          ]
        },


      ]
    },
    {
      path: "*",
      element: <Erro404 {...props} />,
    },

  ])


  //Rotas para MOBILE
  const routerMobile = createBrowserRouter([
    {
      path: "/",
      element: <Outlet />,
      errorElement: <Erro404 {...props} />,
      children: [

        {
          path: "/:nome",
          element: <OutletDelivery />,
          children: [
            {
              path: "/:nome",
              element: <Delivery {...props} />,
            },
            {
              path: "/:nome/pedidos",
              element: <Pedidos {...props} />,
            },
            {
              path: "/:nome/perfil",
              element: <Perfil {...props} />,
            },
          ]
        },

      ]
    },

  ])

  return <RouterProvider router={isMobile ? routerMobile : router} />


}

export default Routes